webpackJsonp([264598414423048],{

/***/ 122:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(122);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Accordion = function (_Component) {
	  _inherits(Accordion, _Component);
	
	  function Accordion() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Accordion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      activeItems: []
	    }, _this.handleClick = function (index) {
	      var activeItems = _this.state.activeItems;
	
	      var activeIndex = activeItems.indexOf(index);
	      if (activeIndex >= 0) {
	        activeItems.splice(activeIndex, 1);
	      } else {
	        activeItems.push(index);
	      }
	      _this.setState({ activeItems: activeItems });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Accordion.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$accordion = this.props.accordion,
	        accordion = _props$accordion === undefined ? [] : _props$accordion;
	
	
	    if (accordion.length <= 0) return null;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'accordion' },
	      accordion.map(function (field, index) {
	        var active = _this2.state.activeItems.indexOf(index) >= 0;
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'item ' + (active ? 'active' : ''),
	            onClick: function onClick() {
	              return _this2.handleClick(index);
	            },
	            key: field.title
	          },
	          _react2.default.createElement(
	            'h4',
	            null,
	            field.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'expand' },
	            _react2.default.createElement(_Content2.default, { src: field.content })
	          )
	        );
	      })
	    );
	  };
	
	  return Accordion;
	}(_react.Component);
	
	exports.default = Accordion;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = function (_Component) {
	  _inherits(Event, _Component);
	
	  function Event(props) {
	    _classCallCheck(this, Event);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      window.addEventListener('scroll', _this.handleScroll);
	    };
	
	    _this.componentWillUnmount = function () {
	      window.removeEventListener('scroll', _this.handleScroll);
	    };
	
	    _this.handleScroll = function () {
	      var eventActive = _this.state.eventActive;
	
	      var elPosition = _this.eventRef.getBoundingClientRect().top;
	      var windowHeight = window.innerHeight;
	      var scrollOffset = window.pageYOffset;
	
	      if (!eventActive && elPosition - (windowHeight - 200) < 0) {
	        _this.setState({
	          eventActive: true
	        });
	      } else if (eventActive && elPosition - (windowHeight - 200) > 0) {
	        _this.setState({
	          eventActive: false
	        });
	      }
	    };
	
	    _this.eventRef = null;
	
	    _this.state = {};
	    return _this;
	  }
	
	  Event.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        year = _props.year,
	        content = _props.content,
	        eventNow = _props.eventNow;
	    var eventActive = this.state.eventActive;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'event ' + (eventActive ? 'active' : '') + ' ' + (eventNow ? 'now' : ''),
	        ref: function ref(el) {
	          return _this2.eventRef = el;
	        },
	        key: year
	      },
	      _react2.default.createElement(
	        'h4',
	        null,
	        year
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        content
	      )
	    );
	  };
	
	  return Event;
	}(_react.Component);
	
	exports.default = Event;
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeftColumn = function LeftColumn(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'column left' },
	    props.content
	  );
	};
	
	exports.default = LeftColumn;
	module.exports = exports['default'];

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(83);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Column = __webpack_require__(14);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var More = function More(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'more' },
	    _react2.default.createElement(
	      'div',
	      { className: 'small title' },
	      _react2.default.createElement(
	        'div',
	        { className: 'small left' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          props.title
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        props.largeTitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'small content' },
	      _react2.default.createElement(
	        _Column2.default,
	        { right: true },
	        _react2.default.createElement(_Content2.default, { src: props.content })
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    ),
	    _react2.default.createElement(_Button2.default, { text: props.buttonText, page: props.buttonLink })
	  );
	};
	
	exports.default = More;
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RightColumn = function RightColumn(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'column right' },
	    props.content
	  );
	};
	
	exports.default = RightColumn;
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(253);
	
	var _Event = __webpack_require__(174);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Timeline = function Timeline(_ref) {
	  var props = _ref.props,
	      timeline = _ref.timeline;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'timeline' },
	      _react2.default.createElement('div', { className: 'line' }),
	      timeline.event.map(function (event, index) {
	        return _react2.default.createElement(_Event2.default, { year: event.year, content: event.content });
	      }),
	      _react2.default.createElement('div', { className: 'clear' })
	    ),
	    _react2.default.createElement(_Event2.default, {
	      year: timeline.eventNow.title,
	      content: timeline.eventNow.content,
	      eventNow: true
	    })
	  );
	};
	
	exports.default = Timeline;
	module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.AboutPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(37);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _LargeTitle = __webpack_require__(38);
	
	var _LargeTitle2 = _interopRequireDefault(_LargeTitle);
	
	var _Column = __webpack_require__(14);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _LeftColumn = __webpack_require__(175);
	
	var _LeftColumn2 = _interopRequireDefault(_LeftColumn);
	
	var _RightColumn = __webpack_require__(177);
	
	var _RightColumn2 = _interopRequireDefault(_RightColumn);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Image = __webpack_require__(17);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Timeline = __webpack_require__(178);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Accordion = __webpack_require__(96);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _More = __webpack_require__(47);
	
	var _More2 = _interopRequireDefault(_More);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageTemplate = exports.AboutPageTemplate = function AboutPageTemplate(_ref) {
	  var title = _ref.title,
	      heroImage = _ref.heroImage,
	      centerImage = _ref.centerImage,
	      about = _ref.about,
	      timeline = _ref.timeline,
	      career = _ref.career,
	      work = _ref.work,
	      more = _ref.more,
	      footerImage = _ref.footerImage,
	      meta = _ref.meta;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta.description })
	    ),
	    _react2.default.createElement(_Hero2.default, { image: heroImage }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, {
	        smallTitle: about.subtitle,
	        title: about.title,
	        largeTitle: about.largeTitle,
	        marginTop: true
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(
	          _Column2.default,
	          { left: true },
	          _react2.default.createElement(_Content2.default, { src: about.leftColumn })
	        ),
	        _react2.default.createElement(
	          _Column2.default,
	          { right: true },
	          _react2.default.createElement(_Content2.default, { src: about.rightColumn })
	        ),
	        _react2.default.createElement('div', { className: 'clear' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, { largeTitle: 'History' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(_Timeline2.default, { timeline: timeline })
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    ),
	    _react2.default.createElement(_Hero2.default, { image: centerImage, center: true }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, {
	        smallTitle: career.subtitle,
	        title: career.title,
	        largeTitle: career.largeTitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(
	          _Column2.default,
	          { left: true },
	          _react2.default.createElement(_Content2.default, { src: career.leftColumn })
	        ),
	        _react2.default.createElement(
	          _Column2.default,
	          { right: true },
	          _react2.default.createElement(_Content2.default, { src: career.rightColumn })
	        ),
	        _react2.default.createElement('div', { className: 'clear' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, {
	        smallTitle: work.subtitle,
	        title: work.title,
	        largeTitle: work.largeTitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(
	          _Column2.default,
	          { left: true },
	          _react2.default.createElement(_Content2.default, { src: work.leftColumn })
	        ),
	        _react2.default.createElement('div', { className: 'clear' }),
	        _react2.default.createElement(_Accordion2.default, { accordion: work.accordion })
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    ),
	    _react2.default.createElement(_More2.default, {
	      largeTitle: more.largeTitle,
	      title: more.title,
	      content: more.content,
	      buttonText: more.buttonText,
	      buttonLink: more.buttonLink
	    }),
	    _react2.default.createElement(_Hero2.default, { image: footerImage, footer: true })
	  );
	};
	
	var AboutPage = function AboutPage(_ref2) {
	  var page = _ref2.data.page;
	  return _react2.default.createElement(AboutPageTemplate, _extends({}, page, page.frontmatter, { body: page.html }));
	};
	
	exports.default = AboutPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-fe13ce7663741391b829.js